import { render, staticRenderFns } from "./UsersListPending.vue?vue&type=template&id=1940619c"
import script from "./UsersListPending.vue?vue&type=script&lang=js"
export * from "./UsersListPending.vue?vue&type=script&lang=js"
import style0 from "./UsersListPending.vue?vue&type=style&index=0&id=1940619c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports